import type { OVPProfile } from '@setplex/tria-api'
import type { ApiOVPProfile, ApiOVPProfileInput } from './index.h'

export const format = ({
  firstName,
  lastName,
  birthday,
  gender,
  primaryLanguage,
  primaryRegion,
}: ApiOVPProfile): OVPProfile => ({
  firstName,
  lastName,
  birthday,
  gender,
  primaryLanguage,
  primaryRegion,
})

export const formatParams = ({
  firstName,
  lastName,
  birthday,
  gender,
  primaryRegion,
}: OVPProfile): Omit<ApiOVPProfileInput, 'primaryLanguage'> => ({
  firstName: firstName || '',
  lastName: lastName || '',
  birthday: birthday || '',
  gender: gender || '',
  primaryRegion: primaryRegion ? { id: primaryRegion.id } : { id: 0 },
})
